/**
 * Synonym Configuration for Query Parser
 */

"use strict";

import { UNI_B_START, UNI_B_END } from './constants.js';

export const SYNONYM_CONFIG = {
    '^т[еэ]тан[А-Яа-я]*': { pattern: String.raw`${UNI_B_START}(?:т[еэ]тан[А-Яа-я]*|thetan)${UNI_B_END}`, flags: 'i' },
    '^трак$': { pattern: String.raw`${UNI_B_START}(?:трак[А-Яа-я]*|track)${UNI_B_END}`, flags: 'i' },
    '^КСХ$': { pattern: String.raw`${UNI_B_START}(?:ксх|hcs)${UNI_B_END}`, flags: 'i' },
    '^(Dn|дн|дианетик[а-я]?|dianetics)$': { pattern: String.raw`${UNI_B_START}(?:Dn|Dianetics|дианетик[а-я]?|дн)${UNI_B_END}`, flags: 'i' },
    '^(саентолог[а-я]+|scn|снт|scientology)$': { pattern: String.raw`${UNI_B_START}(?:Scn|scientology|саентолог[а-я]+)${UNI_B_END}`, flags: 'i' },
    '^саентолог$': { pattern: String.raw`${UNI_B_START}(scientologist)${UNI_B_END}`, flags: 'i' },
    '^гс$': { pattern: String.raw`${UNI_B_START}(?:гс|генетическ[А-Яа-я]*\s+(?:сущност|лин)[А-Яа-я]*)${UNI_B_END}`, flags: 'i' },
    '^(?:инграмм|анатен)[А-Яа-я]*': { pattern: String.raw`(?:инграмм|анатен)[А-Яа-я]*`, flags: 'i' },
    '^(?:д[эе]д)': { pattern: String.raw`${UNI_B_START}(?:д[эе]д)${UNI_B_END}`, flags: 'i' },
    // '^[Оо][Тт](?=[^А-Яа-яЁё]|$)': { 
    //     pattern: String.raw`(?:${UNI_B_START}ОТ[а-яё]*${UNI_B_END}|[Оо]перирующ[а-яё]*\s+[Тт][еэ]тан[а-яё]*|ОПЕРИРУЮЩ[А-ЯЁ]*\s+Т[ЭЕ]ТАН[а-яё]*)`, 
    //     flags: '' 
    // },
    '^ot|от$': { 
        pattern: String.raw`(?:${UNI_B_START}(OT|ОТ)[a-z]?${UNI_B_END}|[Oo]perat[a-z]*\s+[Tt]hetan[a-z]*|OPERAT[A-Z]*\s+THETAN[a-z]*|[Оо]перирующ[а-яё]*\s+[Тт][еэ]тан[а-яё]*)`, 
        flags: 'i'
    },
    '^(?:преклир[А-Яа-я]*|ПК|preclear|[Pp][Cc]s?)$': { 
        pattern: String.raw`(?:преклир[А-Яа-я]*|${UNI_B_START}ПК${UNI_B_END}|[Pp]re[- ]?[Cc]lear|${UNI_B_START}[Pp][Cc]s?${UNI_B_END})`, 
        flags: 'i' 
    },
    '^(?:аро|AR[kC]|арк)$': { 
        pattern: String.raw`(?:${UNI_B_START}(?:AR[KC][Ss]?|аро|арк)(?![- ]\d{2})${UNI_B_END}|(?:аффинити|affinity|Affinität)[\s\-\.,]+(?:реальност[а-я]*|reality|Realität)[\s\-\.,\sund]+(?:комм[а-я]*|comm|komm)[a-z]*)`, 
        flags: 'i' 
    },
    '^(пнв|ptp|[Pp]resent\s+[Tt]ime\s+[Pp]roblem[s]?)$': {
        pattern: String.raw`${UNI_B_START}(?:PTP|пнв|[Pp]resent\s+[Tt]ime\s+[Pp]roblem[s]?)${UNI_B_END}`,
        flags: 'i'
    },
    '^(?:f/? ?n|Floating +Needle)$': {
        pattern: String.raw`(?:${UNI_B_START}F[\s\/]*N${UNI_B_END}|Floating\s+Needle)`,
        flags: 'i'
    },
    '^[Tt][Aa]$|^[Tt]one\s+[Aa]rm$': {
        pattern: String.raw`(?:${UNI_B_START}TA${UNI_B_END}|[Tt]one\s+[Aa]rm)`,
        flags: 'i'
    },
    '^(?:[Cc]/? ?[Ss]|[Cc]ase\s+[Ss]upervisor)$': {
        pattern: String.raw`(?:${UNI_B_START}C[\s\/]*S${UNI_B_END}|[Cc]ase\s+[Ss]upervisor)`,
        flags: 'i'
    },
    '^[Bb][Dd]$|^[Bb]lowdown$': {
        pattern: String.raw`(?:${UNI_B_START}BD${UNI_B_END}|[Bb]lowdown)`,
        flags: 'i'
    },
    '^[Pp][Tt][Ss]$|^[Pp]otential\s+[Tt]rouble\s+[Ss]ource$': {
        pattern: String.raw`(?:${UNI_B_START}PTS${UNI_B_END}|[Pp]otential\s+[Tt]rouble\s+[Ss]ource)`,
        flags: 'i'
    },
    '^[Ee][Pp]$|^[Ee]nd\s+[Pp]henomena$': {
        pattern: String.raw`(?:${UNI_B_START}EP${UNI_B_END}|[Ee]nd\s+[Pp]henomena)`,
        flags: 'i'
    },
    '^[Ss][Pp]$|^[Ss]uppressive\s+[Pp]erson$': {
        pattern: String.raw`(?:${UNI_B_START}SP${UNI_B_END}|[Ss]uppressive\s+[Pp]erson)`,
        flags: 'i'
    },
    '^[Nn][Ee][Dd]$|^[Nn]ew\s+[Ee]ra\s+[Dd]ianetics$': {
        pattern: String.raw`(?:${UNI_B_START}NED${UNI_B_END}|[Nn]ew\s+[Ee]ra\s+[Dd]ianetics)`,
        flags: 'i'
    }
};
